// The one door on the gantt widget (TODO §26/§7.1), mirroring `diagram-engine.ts`.
//
// §7.1 **Lazy.** `@svar-ui/react-gantt` and its sixteen `@svar-ui/*` dependencies are ~950KB
// unpacked, and its stylesheet is another 150KB. A deck with no gantt must download none of
// it, so nothing imports `GanttCanvas` statically — not the block, not the right panel, not
// the export pass. `webpack.config.js` already sets `splitChunks: { chunks: "all" }`, so the
// dynamic import below falls out as its own chunk with no config change. **Verify that from
// the built asset list rather than from intent** (§16.11).
//
// §7.1 **One import specifier.** Every caller goes through `loadGanttCanvas`, so the chunk is
// fetched once and shared: `React.lazy` in `GanttBlock` and the imperative
// `collectGanttImages` in the HTML export path resolve the same module instance.
//
// Unlike Excalidraw there is no asset-path global to set here — but there IS an equivalent
// trap, and it is handled where it belongs, in `GanttCanvas`/`src/styles/gantt.css`: the
// package's theme fetches fonts and its icon set from `cdn.svar.dev` unless told otherwise.

export type GanttCanvasModule = typeof import("@/components/deck/GanttCanvas");

let modulePromise: Promise<GanttCanvasModule> | null = null;

export function loadGanttCanvas(): Promise<GanttCanvasModule> {
  if (!modulePromise) {
    modulePromise = import("@/components/deck/GanttCanvas");
  }
  return modulePromise;
}

// Has the chunk already been fetched? The thumbnail capturer asks before deciding a slide is
// ready to rasterize (§8.2) — a gantt captured while its chunk is still in flight bakes an
// empty box into the cache, and nothing would ever invalidate it.
export function isGanttCanvasLoaded(): boolean {
  return modulePromise !== null;
}
